import { takeEvery, call, all, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import UrlParser from 'utils/parsers/UrlParser';

import {
    FETCH_ACTIVITIES_QUERY,
    FETCH_ACTIVITIES_QUERY_FETCHING,
    FETCH_ACTIVITIES_QUERY_SUCCESS,
    FETCH_ACTIVITIES_QUERY_FAIL
} from 'actions/activitiesActions';

function* fetchActivities(action) {
    const queryString = new UrlParser().convertObjectToQueryStringWithoutEncoding(action.queryParams);

    yield put({
        type: FETCH_ACTIVITIES_QUERY_FETCHING
    });

    try {
        let response = yield call(gcApi.get, `/activitylist-service/activities/search/activities${queryString}`);

        yield put({
            type: FETCH_ACTIVITIES_QUERY_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_ACTIVITIES_QUERY_FAIL
        });
    }
}

// watcher
export const activitiesSagas = [takeEvery(FETCH_ACTIVITIES_QUERY, fetchActivities)];
